import React from 'react';
import { getDeviceSwVersion, getLowestSwVersion } from 'common/utils/helpers';
import { isItBundle } from 'common/utils/deviceTwinUtils';

export const BulkSoftwareDownloadModalSwCell = (props) => {
  let swVersion = 'Unknown';
  let device = props.targetDevice;

  if (!isItBundle(device)) swVersion = getDeviceSwVersion(device);
  else {
    swVersion = getLowestSwVersion(device);
  }

  return (
    <div className="BulkSoftwareDownloadModal_DeviceTable_SwVersionString" data-tip={swVersion}>
      {swVersion}
    </div>
  );
};
